module.exports = __webpack_public_path__ + "static/img/frontpage1.2693658.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/frontpage1.jpg
// module id = uL6C
// module chunks = 0